import axiosAuth from '../../axiosMain';
import axiosPublic from '../../axiosPublic';

async function store(data) {
  let response = await axiosAuth.post('/generate_public_dashboard_token', data);
  return response.data;
}

async function destroy(id) {
  let response = await axiosAuth.delete('/generate_public_dashboard_token/' + id);
  return response.data;
}

async function show() {
  let response = await axiosPublic.get('public/token');
  return response.data;
}

export default {
  store,
  destroy,
  show,
};
